'use client';

import SpinnerCircle from '@/components/loading/SpinnerCircle';

export default function SubmitButton({
  title,
  isSubmitting,
}: {
  title: string;
  isSubmitting: boolean;
}) {
  return (
    <button type="submit" className={`button primary`} disabled={isSubmitting}>
      {isSubmitting ? <SpinnerCircle /> : title}
    </button>
  );
}
